const NUMBER_KEY = 'user-mobile-number';

export const storeMobileNumber = (state) => localStorage.setItem(NUMBER_KEY, JSON.stringify(state));
export const clearStoredMobileNumber = () => localStorage.removeItem(NUMBER_KEY);
export const getStoredMobileNumber = () => JSON.parse(localStorage.getItem(NUMBER_KEY)) || '';
